import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { InvoiceParentContainerComponent, InvoiceRoute } from './invoice.route';
import { InvoiceManagementModule } from './management/invoice-management.module';
import { InvoiceRegisterModule } from './register/invoice-register.module';
import { InvoiceRenumberingModule } from './renumbering/invoice-renumbering.module';
import { InvoiceSetupModule } from './setup/invoice-setup.module';

@NgModule({
    declarations: [InvoiceParentContainerComponent],
    imports: [
        CommonModule,
        UIRouterModule,
        UIRouterModule.forChild({
            states: [InvoiceRoute]
        }),
        InvoiceManagementModule,
        InvoiceSetupModule,
        InvoiceRenumberingModule,
        InvoiceRegisterModule,
    ]
    // exports: [InvoiceManagementModule]
})
export class InvoiceModule {}
